<script setup>
defineProps({stats:Boolean});
const social=inject('profileFollowing');
const counts=computed(()=>social?.data.value);
</script>
<template>
 <section v-if="social" :class="stats?'uo-card pc-card pc-social-stats':'uo-profile-follow-counts'" aria-label="Подписчики и подписки">
  <div v-if="stats" class="pc-heading"><h2>Подписчики и подписки</h2><span class="pc-caption">За всё время</span></div>
  <div v-if="counts" class="uo-follow-count-row">
   <button type="button" :aria-label="'Подписчики: '+counts.followers" @click="social.openList('followers')"><span>Подписчики</span><strong>{{counts.followers}}</strong></button>
   <button type="button" :aria-label="'Подписки: '+counts.following" @click="social.openList('following')"><span>Подписки</span><strong>{{counts.following}}</strong></button>
  </div>
  <p v-else-if="social.error.value" class="pc-caption" role="status">Не удалось загрузить подписки. <button type="button" class="uo-text-link" @click="social.refresh">Повторить</button></p>
 </section>
</template>
<style>
.uo-profile-follow-counts{padding:0 var(--uo-spacing-6) var(--uo-spacing-1)}
.uo-follow-count-row{display:flex;gap:var(--uo-spacing-4);flex-wrap:wrap;align-items:center}
.uo-follow-count-row>button{display:inline-flex;align-items:center;gap:var(--uo-spacing-2);min-height:44px;padding:0;border:0;background:transparent;color:var(--uo-color-text-secondary);font:400 14px/20px var(--uo-typography-fontFamily-ui)}
.uo-follow-count-row strong{color:var(--uo-color-text-primary);font-weight:600}
.uo-follow-count-row>button:hover{color:var(--uo-color-action-primaryBackground);text-decoration:underline}
.uo-follow-count-row>button:focus-visible{outline:2px solid var(--uo-color-border-focus);outline-offset:2px;border-radius:var(--uo-radius-card)}
.pc-social-stats .uo-follow-count-row{gap:var(--uo-spacing-6);margin-top:var(--uo-spacing-2)}
.pc-social-stats .uo-follow-count-row strong{font-size:24px;line-height:32px}
@media(max-width:767px){.uo-profile-follow-counts{padding-inline:var(--uo-spacing-4)}.uo-follow-count-row{gap:var(--uo-spacing-3)}}
</style>
